import React from 'react';
import { Link } from 'react-router-dom';
const Subnavbar = ({ urlData }) => {
  console.log(urlData)
  return (

    <nav className="subNavbar">
      <ul className="subNavbar__group p-0">
        <li><a href="#description">Description</a></li>
        <li><a href="#tools">Tools</a></li>
        <li><a href="#github">Github</a></li>
        {/* <li><a href="#">Pictures</a></li> */}
      </ul>
    </nav>

  );
}

export default Subnavbar;
